import router from "@/router";
import axios from "axios";
import { Message, MessageBox } from "element-ui";
import Cookies from "js-cookie";
// https://nlpdev.sjwxsc.com
function getKey() {
  let token = Cookies.get("Secret-key") || "IbHIx-2JKGN-GXgn0-cdf0a315";
  return token;
}
function getToken() {
  let token = Cookies.get("token") || "";
  return token;
}

axios.interceptors.request.use(
  async config => {
    const baseUrl = window.localStorage.getItem("baseUrl");
    if (baseUrl) {
      config.baseURL = baseUrl;
    }
    //   if (store.getters.token) {
    //     config.headers['Secret-key'] = getToken()
    //   }
    //config.headers['Secret-key'] = getKey()............................
    config.headers["token"] = getToken();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

function reError(res) {
  Message({
    message: res.msg || "请重新登录",
    type: "error",
    duration: 5 * 1000
  });
  router.push({ path: "/" });
  return false;
}

axios.interceptors.response.use(
  response => {
    const res = response.data;
    // return res.code > 200 ? reError(res) : res;
    // if(res.code > 200){
    //   reError(res)
    // }
    if (res.code == 401) {
      reError(res);
    } else {
      return res;
    }
    if (res.code !== 2000) {
      Message({
        message: res.message || "请重新登录",
        type: "error",
        duration: 5 * 1000
      });
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm(
          "您已注销，可以取消以留在此页，或重新登录",
          "确认注销",
          {
            confirmButtonText: "返回登录",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload()
          // })
        });
      }
      return Promise.reject(new Error(res.message || "请求失败"));
    } else {
      return res;
    }
  },
  error => {
    Message({
      message: "请求失败",
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/api/http.js